import KTFormInput from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTFormTextArea from 'general/components/OtherKeenComponents/Forms/KTFormTextArea';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useState } from 'react';

AgencySaleDialogView.propTypes = {
  title: PropTypes.string,
  contentEl: PropTypes.element,
  bodyEl: PropTypes.element,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  showInput: PropTypes.bool,
  inputLabel: PropTypes.arrayOf(PropTypes.string),
  inputType: PropTypes.arrayOf(PropTypes.string),
  iconEl: PropTypes.element,
  cancelButtonText: PropTypes.string,
  confirmButtonText: PropTypes.string,
  removeFooter: PropTypes.bool,
  confirmButtonRed: PropTypes.bool,
  onlyBodyEl: PropTypes.bool,
  additionalInfo: PropTypes.element,
  showAdditionalInfo: PropTypes.bool,
  isFormTextArea: PropTypes.bool,
  isShowConfirmButton: PropTypes.bool,
};

function AgencySaleDialogView({
  title = '',
  contentEl = <></>,
  onCancel,
  onConfirm,
  showInput = false,
  inputLabel = [],
  inputType = ['text'],
  iconEl,
  cancelButtonText = 'Hủy bỏ',
  confirmButtonText = 'Xác nhận',
  bodyEl = <></>,
  removeFooter = false,
  confirmButtonRed = false,
  onlyBodyEl = false,
  additionalInfo = <></>,
  showAdditionalInfo = false,
  isFormTextArea = false,
  isShowConfirmButton = true,
}) {
  // MARK: ---- PROPERTIES ----
  const [inputValue, setInputValue] = useState(inputLabel.map(() => ''));
  const [readyToValidate, setReadyToValidate] = useState(false);

  const [loading, setLoading] = useState(false);

  const handleInputChange = (index, value) => {
    const newInputValues = [...inputValue];
    newInputValues[index] = value;
    setInputValue(newInputValues);
  };
  const handleConfirm = async () => {
    setReadyToValidate(true);

    if (showInput && inputLabel.length > 0 && inputValue.some(val => _.isEmpty(val))) {
      ToastHelper.showError('Vui lòng nhập đầy đủ thông tin');
      return;
    }

    if (loading) return;

    setLoading(true);

    try {
      await onConfirm(showInput ? inputValue : undefined);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="">
      {!onlyBodyEl && (
        <div className={`d-flex flex-column align-items-center justify-content-center text-center px-5 pt-5 ${showAdditionalInfo ? 'pb-2' : 'pb-5'}`}>
          {/* icon */}
          {iconEl && <div className="mb-4">{iconEl}</div>}

          <span style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[800])}>{title}</span>
          <span
            style={{
              ...UIHelper.buildFontStyle('400', '14px', AppColors.gray[600]),
              // lineBreak: 'anywhere',
            }}
          >
            {contentEl}
          </span>

          {/* input */}
          {showInput && inputLabel.length > 0 && (
            <div className='w-100'>
              {!isFormTextArea ? (
                <div className="w-100 mt-4">
                  {inputLabel.map((label, index) => (
                    <div key={index} className="text-left mb-3">
                      <div>{UIHelper.buildFormLabel(label, true)}</div>
                      <KTFormInput
                        name={`input-${index}`}
                        placeholder={`Nhập ${label?.toLowerCase()}`}
                        type={inputType[index] ?? 'text'}
                        value={inputValue[index] || ''}
                        onChange={(value) => handleInputChange(index, value)}
                        enableCheckValid
                        isValid={Utils.isValid(inputValue[index])}
                        isTouched={readyToValidate}
                        feedbackText={!Utils.isValid(inputValue[index])
                          ? `Vui lòng nhập ${label?.toLowerCase()}`
                          : ''
                        }
                      />
                    </div>
                  ))}
                </div>
              ) : (
                <div className="w-100 mt-4">
                  {inputLabel.map((label, index) => (
                    <div key={index} className="text-left mb-3">
                      <div>{UIHelper.buildFormLabel(label, true)}</div>
                      <KTFormTextArea
                        name={`input-${index}`}
                        placeholder={`Nhập ${label?.toLowerCase()}`}
                        value={inputValue[index] || ''}
                        onChange={(value) => handleInputChange(index, value)}
                        row={4}
                        enableCheckValid
                        isValid={Utils.isValid(inputValue[index])}
                        isTouched={readyToValidate}
                        feedbackText={!Utils.isValid(inputValue[index])
                          ? `Vui lòng nhập ${label?.toLowerCase()}`
                          : ''
                        }
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {showAdditionalInfo && (
        <div className='px-5'>
          <div className='py-5' style={{ borderTop: `1px dashed ${AppColors.gray[300]}` }}>
            {additionalInfo}
          </div>
        </div>
      )}

      {/* body */}
      {bodyEl && <div className="">{bodyEl}</div>}

      {/* footer */}
      {!removeFooter && (
        <div
          className="d-flex align-items-center gap-3 px-4 py-3"
          style={{
            borderTop: `1px solid ${AppColors.gray[200]}`,
          }}
        >
          {UIHelper.buildNegativeButton(cancelButtonText, onCancel, null, true)}
          {isShowConfirmButton &&
            <>
              {Utils.isValid(confirmButtonText) ? (
                confirmButtonRed ? (
                  UIHelper.buildRedButton(
                    confirmButtonText,
                    handleConfirm,
                    null,
                    true,
                    loading,
                  )
                ) : (
                  UIHelper.buildGreenButton(
                    confirmButtonText,
                    handleConfirm,
                    null,
                    true,
                    loading,
                  )
                )
              ) : (
                <></>
              )}
            </>
          }
        </div>
      )}
    </div>
  );
}

export default AgencySaleDialogView;
